export default __webpack_public_path__ + "static/branding1-79d0ff878cf1c5600722a0662d4b7db7.webp";